<template>
   
 <div id="welcome-page">
    <h1 id="title">PORTFOLIO</h1>
    <h2>Alexandre MEUX</h2>
</div> 

</template>














<script>





export default {
    name: 'HomePage',
    data() {
        return {
            rand: null,
            links: [
                '/portfolio/graphisme',
                '/portfolio/audiovisuel',
                '/portfolio/developpement-web',
                '/portfolio/ui-ux',
                '/portfolio/tous',
                '/competences',
                '/a-propos',
                '/contact'
            ]
        }
    },
    created() {
        this.rand = Math.floor(Math.random() * this.links.length);
    }
};





</script>
















<style scoped>

#welcome-page{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:20rem 0
}

#welcome-page h2{
    margin-top: 5rem;
}

#title{
    font-size: 14vw;
    text-align: center;
    font-weight: 900;
    color: var(--white);
    padding: 0 2rem;
    letter-spacing: -5px;
    text-shadow: 1px 1px 12px var(--white);
    box-shadow: var(--box-shadow-1);
    background: linear-gradient(135deg, var(--white), var(--light-blue),var(--gray-hover) , var(--yellow-white), var(--gray));
    background-size: 600% 600%;
    animation: gradientBG 18s ease infinite;
}

@keyframes gradientBG {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }

.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
}

.block {
    gap: 4rem;
    padding: 12% 4%;
}

.social-media-item img{
    width: 4rem;
}

.social-media div a {
    background: var(--yellow-white);
    transition: all 0.25s ease-in;
    border-radius: var(--circle-radius);
    white-space: nowrap;
    box-shadow: var(--box-shadow-1);
}

.social-media div a:hover {
    z-index: 10;
    transform: scale(1.1);
    opacity: 1;
}

.block1,
.block2 {
    gap: 2.5rem;
    align-items: flex-start;
}

.social-media {
    gap: 2rem;
    flex-wrap: wrap;
}

.social-media p {
    color: black;
    padding: 0.2rem 0.8rem;
    text-transform: lowercase;
    font-weight: 600;
}












.card img {
    width: 40rem;
    border: 6px ridge var(--gray);
}

.card {
    perspective: 1000px;
    transition: all 0.15s ease;
    background: var(--yellow-white);
    height: -webkit-fill-available;
    padding: 10rem 0;
    display: grid;
    place-items: center;
    border-left: var(--light-gray-border);
    min-height: 75vh;
}

.card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.6s;
    transform-style: preserve-3d;
}

.card:hover .card-inner .card-front{
    transform: scale(1.125) rotateX(32deg) rotateY(22deg);
    box-shadow: var(--box-shadow-1);
}

.card-front,
.card-back {
    position: absolute;
    backface-visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s cubic-bezier(0.18, 1.41, 0.32, 1.27);
}

.card-back {
    transform: rotateY(180deg);
    background: var(--bck);
    border: var(--double-white);
    min-height: 350px;
    min-width: 350px;
}










@media (max-width:935px) {
    .grid {
        display: flex;
        flex-direction: column-reverse;
    }

    .card {
        border-left: 0;
        border-bottom: var(--light-gray-border);
    }
}

</style>